
import { OnInit, OnChanges, Component, Input, Output, ChangeDetectorRef, Inject, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../security/auth.service';
import jwt_decode from "jwt-decode";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ProductCategoryService } from '../services/productcategory.service';
import { environment } from 'src/environments/environment';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  //hostURL = environment.hostName;
  //logoutURL = environment.redirectURLForLogout;
  username: any;
  isLoggedIn$: Observable<boolean>;
  groups: any;
  isAdmin: boolean=false;
  searchTerm = '';
  private readonly _destroying$ = new Subject<void>();
  isIframe = false;
  loginDisplay = false;
  displayedColumns: string[] = ['claim', 'value'];
  dataSource: any = [];
  constructor(private router: Router, private activatedRoute: ActivatedRoute, public storage: StorageService,
    private service: ProductCategoryService, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private authService: MsalService, private msalBroadcastService: MsalBroadcastService) {


    //   const items = { ...localStorage };
    //  // debugger

    //    if (items.TokenInfo != undefined) {
    //       var clienttoken = jwt_decode(JSON.parse(items.TokenInfo).access_token);
    //       this.username = "Welcome, " + clienttoken["firstname"] + " " + clienttoken["lastname"];
    //       this.groups = clienttoken["groups"].split(',');

    //       this.isAdmin = this.groups.indexOf("GPI-Aces-Admins", 0) != -1;
    //          if (!this.isAdmin) {
    //         this.router.navigate(['/accessdenied']);
    //       }
    //     }
  }

  // checkAndSetActiveAccount() {
  //   /**
  //    * If no active account set but there are accounts signed in, sets first account to active account
  //    * To use active account set here, subscribe to inProgress$ first in your component
  //    * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
  //    */
  //   let activeAccount = this.authService.instance.getActiveAccount();

  //   if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
  //     let accounts = this.authService.instance.getAllAccounts();
  //     this.authService.instance.setActiveAccount(accounts[0]);
  //   }
  // }
  async isUserInGroup(groupName: string): Promise<boolean> {
    try {
      const accounts = this.authService.instance.getAllAccounts();
      if (accounts.length === 0) {
        return false;
      }

      const response: AuthenticationResult = await this.authService.instance.acquireTokenSilent({
        scopes: ['openid', 'profile', 'user.read','GroupMember.Read.All'],
        account: accounts[0],
      });

      const groups = response.idTokenClaims?.['groups'];
      this.username=response.idTokenClaims?.['name'];
      const isMember = groups.includes(groupName);
      this.isAdmin=groups.includes(groupName);
      if(!this.isAdmin)
      {
        this.router.navigate(['/accessdenied']);
      }
      return isMember;
    } catch (error) {
      console.error('Error checking group membership:', error);
      return false;
    }
  }
  
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    this.isUserInGroup(environment.adminADGroupName);

  }
  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  onLogout() {
    this.authService.logout();
    this.isAdmin = false;
   
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      takeUntil(this._destroying$)
    )
    .subscribe((result: EventMessage) => {
      console.log(result);
      const payload = result.payload as AuthenticationResult;
      this.authService.instance.setActiveAccount(payload.account);
    });
    
    this.msalBroadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None)
    )
    .subscribe(() => {
      this.setLoginDisplay();
    });

  }

 
  OnSubmit() {
    //check if it's a number and 9 digits
    //then get product id from part number then redirect
    let isnum = /^\d+$/.test(this.searchTerm);
    if (isnum && this.searchTerm.length == 9) {
      this.service.getProductIdByPartNumber(this.searchTerm)
        .subscribe((data: any) => {
          var productId = data;
          this.router.navigate(['/specpage/' + productId]);
          // console.log('test');
        });
    }
    //allows searches to be done from search results page
    //if left true then the page doesn't load results
    if (this.router.url.includes('/search')) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }
    this.router.navigate(['/search/' + this.searchTerm]);
  }
}